const SignHereIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 13.3333L8 2.66663M8 13.3333L4 9.33329M8 13.3333L12 9.33329"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SignHereIcon;
